module.exports = __webpack_public_path__ + "static/img/ballista1.59a0ee4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/ballista1.png
// module id = sjJw
// module chunks = 0